// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2TugH","colMin":"styles_colMin__3GFKo","colCheckbox":"styles_colCheckbox__2Tcy-"};